var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path, _rect17, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 60,
    viewBox: "0 0 290 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 208.333,
    y: -28.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 208.333,
    y: 13,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6667,
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 83.3333,
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 166.667,
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 208.333,
    y: 54.667,
    width: 41.6667,
    height: 41.6667,
    rx: 4.5977,
    stroke: "#F0F0F0",
    strokeWidth: 0.431035
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 -66.8848V-33.2641C166.667 -30.7248 168.725 -28.6664 171.264 -28.6664H203.736C206.275 -28.6664 208.333 -26.6079 208.333 -24.0687V8.40259C208.333 10.9418 210.392 13.0003 212.931 13.0003H245.402C247.942 13.0003 250 15.0588 250 17.598V50.0693C250 52.6085 252.058 54.667 254.598 54.667H287.069C289.608 54.667 291.667 56.7254 291.667 59.2647V91.7359C291.667 94.2752 293.725 96.3336 296.264 96.3336H329.885M125 -66.8848V-33.2641C125 -30.7248 127.058 -28.6664 129.598 -28.6664H162.069C164.608 -28.6664 166.667 -26.6079 166.667 -24.0687V8.40259C166.667 10.9418 168.725 13.0003 171.264 13.0003H203.736C206.275 13.0003 208.333 15.0588 208.333 17.598V50.0693C208.333 52.6085 206.275 54.667 203.736 54.667H171.264C168.725 54.667 166.667 52.6085 166.667 50.0693V17.0233L166.626 16.7517C166.318 14.6693 164.55 13.1143 162.446 13.0738L158.621 13.0003H129.598C127.058 13.0003 125 15.0588 125 17.598V50.0693C125 52.6085 127.058 54.667 129.598 54.667H162.356L163.448 54.7397C165.259 54.8605 166.667 56.365 166.667 58.1804V61.7072M166.667 58.1152V91.7359C166.667 94.2752 168.725 96.3336 171.264 96.3336H203.736C206.275 96.3336 208.333 98.3921 208.333 100.931V133.403C208.333 135.942 210.392 138 212.931 138H245.402C247.942 138 250 140.059 250 142.598V175.069C250 177.608 252.058 179.667 254.598 179.667H287.069C289.608 179.667 291.667 181.725 291.667 184.265V216.736C291.667 219.275 293.725 221.334 296.264 221.334H329.885",
    stroke: "url(#paint0_linear_0_1)",
    strokeOpacity: 0.8,
    strokeWidth: 0.431035
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    y: 190.621,
    width: 233.621,
    height: 125,
    transform: "rotate(-90 0 190.621)",
    fill: "url(#paint1_linear_0_1)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.218,
    cy: -71.1611,
    rx: 155.46,
    ry: 132.471,
    fill: "url(#paint2_radial_0_1)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 125,
    y1: -66.8848,
    x2: 325.287,
    y2: 180.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0819437,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#12C2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#C471ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#F64F59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 116.81,
    y1: 190.621,
    x2: 116.81,
    y2: 315.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.218 -71.1611) rotate(90) scale(132.471 155.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.ee583ff66856dd37fbf7e972e1262eb6.svg";
export { ForwardRef as ReactComponent };